import React from 'react';
import { faEye, faEdit, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import IconButton from './IconButton';
import { RecentConsulta } from '../services/consultasService';

interface RecentConsultasProps {
  consultas: RecentConsulta[];
  loading: boolean;
}

export default function RecentConsultas({
  consultas,
  loading
}: RecentConsultasProps): React.ReactElement {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="bg-white rounded-lg border shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Consultas Recentes</h3>
        <div className="flex justify-center items-center h-32">
          <img className="w-12 h-12" src="/loading.svg" alt="loading" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border shadow-sm p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Consultas Recentes</h3>

      {consultas.length === 0 ? (
        <p className="text-gray-500 text-center py-8">Nenhuma consulta encontrada</p>
      ) : (
        <div className="space-y-3">
          {consultas.map(consulta => (
            <div
              key={consulta.id}
              className="flex items-center justify-between p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors"
            >
              <div className="flex-1">
                <div className="flex items-center space-x-2">
                  <FontAwesomeIcon icon={faClock} className="text-gray-400 w-4 h-4" />
                  <span className="text-sm text-gray-500">
                    {consulta.created_at &&
                      new Date(consulta.created_at).toLocaleDateString('pt-BR')}{' '}
                    às{' '}
                    {consulta.created_at &&
                      new Date(consulta.created_at).toLocaleTimeString('pt-BR', {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                  </span>
                </div>
                <p className="font-medium text-gray-900">{consulta.paciente?.nome}</p>
                {consulta.queixa && (
                  <p className="text-sm text-gray-600 truncate">{consulta.queixa}</p>
                )}
              </div>

              <div className="flex space-x-2">
                <IconButton
                  onClick={() => navigate(`/consultas/print/${consulta.id}`)}
                  icon={faEye}
                  variant="primary"
                  tooltip="Visualizar consulta"
                />
                <IconButton
                  onClick={() => navigate(`/consultas/${consulta.id}`)}
                  icon={faEdit}
                  variant="success"
                  tooltip="Editar consulta"
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {consultas.length > 0 && (
        <div className="mt-4 text-center">
          <button
            onClick={() => navigate('/consultas')}
            className="text-blue-600 hover:text-blue-700 text-sm font-medium"
          >
            Ver todas as consultas →
          </button>
        </div>
      )}
    </div>
  );
}
